import React, { useState } from 'react'
import {firebase} from "../../../firebase/firebaseConfig";
import {Button} from "react-bootstrap";

export default function DateFilter(props) {
  const [bold, setBold] = useState('All Time');

  const handleClick = (e) => {
    if (e.target.innerText === "Past Year") {
      const end = new Date();
      const start = end.setFullYear(end.getFullYear() - 1);
      props.setStartDate(new Date(start));
    } else if (e.target.innerText === "Past Month") {
      const end = new Date();
      const start = end.setMonth(end.getMonth() - 1);
      props.setStartDate(new Date(start));
    } else if (e.target.innerText === "Today") {
      const end = new Date();
      const start = end.setDate(end.getDate() - 1);
      props.setStartDate(new Date(start));
    } else if (e.target.innerText === 'All Time') {
      props.setStartDate(null);
    }
    firebase.analytics().logEvent('date_filter', {start: e.target.innerText});
    setBold(e.target.innerText);
  }

  const baseStyles = "text-dark px-0";

  return (
    <>
    <div className="row no-gutters mt-5 date-filter-buttons">
      <div className="col-sm text-md-left text-xs-center advanced-search-link"><Button variant="link" className="text-dark mb-0 pb-0 px-0" onClick={() => props.setShowAdvanced(true)}>Advanced Search</Button></div>
      <div className="text-md-right text-xs-center date-toggles col-sm">
        <span><Button variant="link" className={bold === 'All Time' ? `${baseStyles} font-weight-bold` : baseStyles} onClick={handleClick} >All Time</Button> | </span>
        <span><Button variant="link" className={bold === 'Past Year' ? `${baseStyles} font-weight-bold` : baseStyles} onClick={handleClick} >Past Year</Button> | </span>
        <span><Button variant="link" className={bold === 'Past Month' ? `${baseStyles} font-weight-bold` : baseStyles} onClick={handleClick} >Past Month</Button> | </span>
        <span><Button variant="link" className={bold === 'Today' ? `${baseStyles} font-weight-bold` : baseStyles} onClick={handleClick} >Today</Button></span>
      </div>
    </div>
    </>
  )
}
